<div class="col-md-12">
  <h3 translate="accounts.connectedDebitCards"></h3>
</div>
<div class="col-md-12" ng-repeat="card in accounts.selectedAccount.cardList">
  <div class="debit-card-group debit-card-group-slo clearfix"
    ng-class="{'debit-card-group-blocked': (card.cardStatus !== 'Active')}">
    <div class="col-xs-12 col-md-3">
      <div class="connected-debit-card-widget"></div>
    </div>
    <div class="col-xs-12 col-md-6">
      <h3>
        <span ng-if="card.hasOwnProperty('friendlyName')">{{card.friendlyName}}</span>
        <span ng-if="!card.hasOwnProperty('friendlyName')">{{accounts.selectedAccount.friendlyName}}</span>
      </h3>
      <div ng-show="card.cardNumber">
        <span class="card-property-label" translate="accounts.creditCardNumber"></span>:
        <span class="card-property-value">{{accounts.formatCardNumber(card.cardNumber)}}</span>
      </div>
      <!-- <h5 ng-show="card.cardTypeDescription">{{card.cardTypeDescription}}</h5> -->
      <div ng-show="card.validToDate">
        <span class="card-property-label" translate="accounts.expDate_SLO"></span>:
        <span class="card-property-value">{{card.validToDate | date: "MM.yyyy"}} </span>
      </div>
      <div ng-show="card.cardStatus">
        <span class="card-property-label" translate="accounts.cardStatus"></span>:
        <span class="card-property-value">{{'accounts.'+card.cardStatus | translate }}</span>
      </div>
      <div ng-if="card.payDate">
        <span class="card-property-label" translate="accounts.accDueDate"></span>:
        <span class="card-property-value">{{card.payDate | date: 'd.'}}
      </div>
      <div ng-if="card.limit">
        <span class="card-property-label" translate="accounts.accBalanceSlo"></span>:
        <span class="card-property-value">{{card.limit.limit | number:2}} {{card.limit.currency}} </span>
      </div>
      <div ng-if="card.limit">
        <span class="card-property-label" translate="accounts.accBalance"></span>:
        <span class="card-property-value">{{card.limit.usedLimit | number:2}} {{card.limit.currency}} </span>
      </div>
      <div ng-if="card.limit">
        <span class="card-property-label" translate="accounts.accAvailableToSpend"></span>:
        <span class="card-property-value">{{card.limit.availableLimit | number:2}} {{card.limit.currency}} </span>
      </div>
      <div ng-if="card.cardType == 0 && !card.limit">
        <span class="card-property-label" translate="accounts.limit"></span>:
        <span translate="dashboard.show" class="text-underline cursor-pointer card-property-value"
          ng-click="accounts.showLimit(card)"></span>
      </div>
      <div ng-if="card.cardType == 0">
        <span class="card-property-label" translate="accounts.nextPaymentDate"></span>:
        <span ng-if="!card.nextPayment" translate="dashboard.show" class="text-underline cursor-pointer card-property-value"
          ng-click="accounts.showNextPayment(card)"></span>
        <span ng-if="card.nextPayment" class="card-property-value">{{card.nextPayment.amount | number:2}} {{card.nextPayment.currency}} </span>
      </div>
    </div>
    <div class="col-xs-12 col-md-3">

      <button class="btn btn-info btn-block" ng-if="(card.cardStatus === 'Active' || card.cardStatus === 'Blocked')"
        ng-disabled="card.selected" ng-class="{'btn-card-active': (card.cardStatus === 'Active' && !card.temporaryStatus),
                         'btn-card-blocked': (card.cardStatus === 'Blocked' || card.temporaryStatus)}"
        ng-click="accounts.updateCardStatusCro()">
        <span ng-show="card.cardStatus === 'Active'" translate="accounts.blockCard"></span>
        <span ng-show="card.cardStatus === 'Blocked'" translate="accounts.unblockCard"></span>
      </button>

      <button class="btn btn-info btn-block btn-card-active" ng-if="accounts.selectedAccount.accountType.group == 'CardAccountTypes'
              && accounts.selectedAccount.isOwn && card.cardStatus === 'Active'"
        data-ui-sref="masterCardOrder({accountId: accounts.selectedAccount.accountId, cardId: card.cardId })">
        <span translate="masterCardOrder.orderLimit">Order limit</span>
      </button>
      <!-- SHOW FOR NOW - PIN OVER SMS - START -->
      <button class="btn btn-info btn-block btn-card-active" ng-if="accounts.selectedAccount.accountType.group == 'CardAccountTypes'
              && accounts.selectedAccount.isOwn && card.cardStatus === 'Active'"
        data-ui-sref="reorderPinMasterCard({accountId: accounts.selectedAccount.accountId, cardId: card.cardId })">
        <span translate="masterCardOrder.reorderPIN">Reorder PIN</span>
      </button>
      <!-- SHOW FOR NOW - PIN OVER SMS - START -->
    </div>
    <div class="col-xs-12">
      <div class="msg-tab-container m-t-10 cursor-pointer">
        <div class="msg-tab col-xs-4" ng-class="{'selected':card.selectedTab=='waiting-queue'}"
          ng-click="accounts.toggleCardTab($event, card, 'waiting-queue')">
          <a translate="accounts.waiting-queue"></a>
        </div>
        <div class="msg-tab col-xs-4 cursor-pointer" ng-class="{'selected':card.selectedTab=='archive'}"
          ng-click="accounts.toggleCardTab($event, card, 'archive')">
          <a translate="accounts.archive"></a>
        </div>
        <div ng-if="card.cardType == 0" class="msg-tab col-xs-4 cursor-pointer"
          ng-class="{'selected':card.selectedTab=='statements'}"
          ng-click="accounts.toggleCardTab($event, card, 'statements')">
          <a translate="accounts.statements"></a>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <div ng-if="card.selectedTab=='waiting-queue'" data-ng-include="'accounts/connected-cards-transactions.tpl.html'">
      </div>
      <div ng-if="card.selectedTab=='archive'" class="m-t-10">

        <div class="col-md-6 p-0">
    
          <div data-ng-include="'accounts/accounts-transaction-filter.tpl.html'"></div>
        </div>
        <div class="col-sm-6">
          <span ng-if="accounts.selectedAccount.isOwn" ng-click="accounts.exportTransactions()"
            class="position-absolute icon-excel"></span>
          <div id="periodViewSelector" class="period-selector" ng-click='accounts.showSubmenu("transactions")'>
            <div class="period-view-select-div left"><span translate="accounts.accPeriod"></span>:</div>
            <div class="period-view-select-div right period-margin">
              <div class="dropdown acc-period-select" ng-init="periodSelectorLabel='This week'">
                <button class="btn btn-default dropdown-toggle" style="font-size: 14px;padding: 0 5px" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  {{accounts.selectedPeriod.description | translate}}
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                  <li data-ng-repeat="period in accounts.periodList">
                    <a href ng-click="accounts.changeTransactionPeriod(period)">{{period.description | translate}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div data-ng-include="'accounts/accounts-transactions.tpl.html'"></div>
      </div>
      <div ng-if="card.selectedTab=='statements' && card.cardType == 0"
        data-ng-include="'accounts/accounts-statements.tpl.html'"></div>
    </div>
  </div>

</div>